import { RecipientType } from '../../api/model/common/RecipientType';
import RecipientSelector from './RecipientSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const UserSelector = ({
  onChange,
  appId,
  defaultValue,
  disabled,
  clearable
}) => {
  const labelKey = 'shareWithThirdPartyComponentLibrary.userSelector.label';
  const placeholderKey = 'shareWithThirdPartyComponentLibrary.userSelector.placeholder';
  const alertTitleTranslationKey = 'shareWithThirdPartyComponentLibrary.userSelector.fetchingError.title';
  return /*#__PURE__*/_jsx(RecipientSelector, {
    onChange: onChange,
    appId: appId,
    recipientType: RecipientType.USER,
    selectorAppearanceConfig: {
      labelKey,
      placeholderKey,
      alertTitleTranslationKey,
      clearable: clearable !== undefined ? clearable : false
    },
    defaultValue: defaultValue,
    disabled: disabled
  });
};
export default UserSelector;